import React from 'react'
import { DateFormat, DisplaySettings } from '../models/shared/Settings';

interface Props {
    time: number
    format: DateFormat
    displaySettings?: DisplaySettings;
}

const formatTime = (seconds: number, format: DateFormat) => {
    const date = new Date(seconds * 1000);

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    if (format === 'DD/MM/YYYY') {
        return `${day}/${month}/${year}`;
    } else {
        return `${month}/${day}/${year}`;
    }
}

export default function Time({ time, format, displaySettings }: Props) {
    if (format === 'Hide') {
        return null;
    }

    const containerStyle: React.CSSProperties = {}
    if (displaySettings?.backgroundColor) {
        containerStyle['backgroundColor'] = displaySettings.backgroundColor;
    }
    if (displaySettings?.textColor) {
        containerStyle['color'] = displaySettings.textColor;
    }
    return (
        <div className='time' style={containerStyle}>{formatTime(time, format)}</div>
    )
}
